import React from 'react';
import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import {
  fetchDepartments,
  createDepartment,
  updateDepartment,
  deleteDepartment,
} from '../../store/actions/department';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';

class Departments extends React.Component {
  state = {
    openModal: false,
    currentItem: {
      id: null,
      name: '',
    },
    currentAction: null,
  };

  componentDidMount() {
    this.props.onFetchDepartments();
  }

  handleActionClick = (action, item) => {
    if (item) {
      this.setState({ openModal: true, currentItem: item, currentAction: action });
    } else {
      this.setState({
        openModal: true,
        currentItem: { id: null, name: '' },
        currentAction: action,
      });
    }
  };

  handleActionCancel = () => {
    this.setState({ openModal: false });
  };

  handleActionConfirm = (event) => {
    event.preventDefault();
    if (this.state.currentAction === 'Adicionar') {
      this.props.onCreateDepartment({ name: this.state.currentItem.name });
    }
    if (this.state.currentAction === 'Editar') {
      this.props.onUpdateDepartment(this.state.currentItem);
    }
    if (this.state.currentAction === 'Excluir') {
      this.props.onDeleteDepartment(this.state.currentItem.id);
    }
    this.handleActionCancel();
  };

  handleChange = (event) => {
    this.setState({
      currentItem: { ...this.state.currentItem, name: event.target.value },
    });
  };

  render() {
    const { departments, loading } = this.props;
    const { currentItem, currentAction } = this.state;

    const columns = [{ name: 'name', label: 'Departamento' }];

    const actions = [
      {
        name: 'Editar',
        icon: EditIcon,
        onClick: item => this.handleActionClick('Editar', item),
      },
      {
        name: 'Excluir',
        icon: DeleteIcon,
        onClick: item => this.handleActionClick('Excluir', item),
      },
    ];

    const departmentAlphabetical = departments.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return (
      <React.Fragment>
        <ContentHeader
          title="Gerência de Departamentos"
          subtitle="Listagem de departamentos cadastrados na empresa"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.handleActionClick('Adicionar')}
          >
            <AddIcon /> ADICIONAR
          </Button>
        </ContentHeader>

        <Paper elevation={2}>
          <DataTable rows={departmentAlphabetical} columns={columns} actions={actions} loading={loading} />
        </Paper>

        <Dialog open={this.state.openModal} onClose={this.handleActionCancel}>
          <DialogTitle>{currentAction} departamento</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {currentAction === 'Excluir'
                ? 'Você tem certeza que deseja efetuar esta ação?'
                : 'Por favor, preencha o campo a seguir com o nome do departamento'}
            </DialogContentText>
            {currentAction !== 'Excluir' ? (
              <form onSubmit={this.handleActionConfirm}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="name"
                  label="Departamento"
                  type="text"
                  onChange={this.handleChange}
                  value={currentItem.name}
                  fullWidth
                  required
                />
              </form>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={this.handleActionConfirm}
              autoFocus={currentAction === 'Excluir'}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  departments: state.department.departments,
});

const mapDispatchToProps = dispatch => ({
  onFetchDepartments: () => dispatch(fetchDepartments()),
  onCreateDepartment: name => dispatch(createDepartment(name)),
  onUpdateDepartment: data => dispatch(updateDepartment(data)),
  onDeleteDepartment: id => dispatch(deleteDepartment(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Departments);
